import client from "./config";
import { convertNum } from "helper/convert-num";
import { convertDate, convertTime, DATE_FORMATS } from "helper/date";

//////////////// login Colleague ////////////////
const loginColleagueUrl = "/user/login/colleague";
export const loginColleagueRequest = async (values) => {
  let data = {
    phone_number: convertNum(values.phone_number),
    password: convertNum(values.password),
  };
  return client.post(loginColleagueUrl, data);
};

export const GetAllProductsRequest = (values) =>
  client.get(
    `${getProductUrl}?skip=${values.skip}&limit=${values.limit ?? 10}
    ${values.search ? "&search=" + convertNum(values.search) : ""}`
  );

export const GetAllProductsSearchRequest = (values) =>
  client.get(
    `${getProductUrl}${
      values.search ? "?search=" + convertNum(values.search) : ""
    }`
  );

//////////////// Home Page ////////////////
const homePageUrl = "/page/index";
export const HomePageRequest = () => client.get(homePageUrl);

//////////////// stats ////////////////
const getStatusUrl = "/user/stat";
export const getStatusRequest = () => client.get(getStatusUrl);

//////////////// Send Otp ////////////////
const sendOtpUrl = "/user/login/send_otp";

export const sendOtpRequest = (values) => client.post(sendOtpUrl, values);

//////////////// login Otp ////////////////
const loginOtpUrl = "/user/login/otp";
export const loginOtpRequest = async (values) => {
  let data = {
    phone_number: convertNum(values.phone_number),
    otp: convertNum(values.otp),
  };
  return client.post(loginOtpUrl, data);
};

//////////////// Signup ////////////////
const addedNameUrl = "/user/info";

export const addedNameRequest = (values) => {
  const formData = new FormData();

  formData.append("full_name", values.full_name);
  formData.append("_method", "put");

  return client.post(`${addedNameUrl}`, formData);
};

//////////////// Add To Shopping Cart ////////////////
const addToShoppingCartUrl = "/user/cart";
export const addToShoppingCartRequest = (values) => {
  let data = {
    product_color_id: values.productColorId,
    quantity: values.quantity,
  };
  return client.post(addToShoppingCartUrl, data);
};

//////////////// user info ////////////////
const getUserInfoUrl = "/user/info";
export const getUserInfoRequest = () => client.get(getUserInfoUrl);
export const updateNormalUserRequest = (values) => {
  const formData = new FormData();

  formData.append("full_name", values.full_name);
  values.email && formData.append("email", values.email);

  formData.append("_method", "put");

  return client.post(`${getUserInfoUrl}`, formData);
};

//////////////// user address ////////////////
const UserAddressUrl = "/user/address";
export const getUserAddressRequest = (values) =>
  client.get(
    `${UserAddressUrl}?category_id=${values.id}&skip=${values.skip}&limit=${
      values.limit ?? 10
    }`
  );
export const getUserAddressByIdRequest = (id) =>
  client.get(`${UserAddressUrl}/${id}`);
export const deleteUserAddressRequest = (id) =>
  client.delete(`${UserAddressUrl}/${id}`);
export const addUserAddressRequest = (values) => {
  let data = {
    address: values.address,
    state: values.state,
    city: values.city,
    postal_code: values.postal_code,
  };
  return client.post(UserAddressUrl, data);
};
export const updateUserAddressRequest = (values) => {
  let data = {
    address: values.address,
    state: values.state,
    city: values.city,
    postal_code: values.postal_code,
  };

  return client.put(`${UserAddressUrl}/${values.id}`, data);
};

//////////////// notification ////////////////
const notificationUrl = "/user/notification";
export const getNotificationRequest = (values) => {
  return client.get(
    `${notificationUrl}?category_id=${values.id}&skip=${values.skip}&limit=${
      values.limit ?? 10
    }&type=${values.type}`
  );
};
export const getNotificationbyIdRequest = (id) =>
  client.get(`${notificationUrl}/${id}`);

//////////////// Get Accessory Products Whit Category Id   ////////////////
const getProductUrl = "/product";

//////////////// Get sitemap ////////////////
export const GetsitemapAllProductsRequest = () =>
  client.get(`${getProductUrl}`);

export const GetAccessoryProductsRequest = (values) =>
  client.get(
    `${getProductUrl}?category_id=${values.id}&skip=${values.skip}&limit=${
      values.limit ?? 10
    }`
  );

//////////////// Get Accessory All Products  ////////////////
export const GetAccessoryAllProductsRequest = (values) =>
  client.get(
    `${getProductUrl}?category_type=اکسسوری&skip=${values.skip}&limit=${
      values.limit ?? 10
    }`
  );
//////////////// Get Furniture All Products  ////////////////
export const GetFurnitureAllProductsRequest = (values) =>
  client.get(
    `${getProductUrl}?category_type=مبلمان&skip=${values.skip}&limit=${
      values.limit ?? 10
    }`
  );

//////////////// Get Design Whit Category Id  ////////////////
const getDesignCategoryUrl = "/design";
export const GetDesignWhitCategoryRequest = (values) =>
  client.get(`${getDesignCategoryUrl}?category_id=${values.id}`);

//////////////// Get Products Whit Design Category Id Filter ////////////////
const getProductsFilterUrl = "/product";
export const getProductsFilterRequest = (values) =>
  client.get(
    `${getProductsFilterUrl}?design_ids=${values.designIds}&skip=${
      values.skip
    }&limit=${values.limit ?? 10}`
  );

//////////////// Get Products  ////////////////
const getImageProduct = "/product_color_image";

//////////////// Get Products Details  ////////////////
const getProductDetailsUrl = "/page/product_details";
export const getProductDetailsRequest = (id) => {
  return client.get(`${getProductDetailsUrl}/${id}`);
};

//////////////// Get Product Color Images  ////////////////
export const getImagesColorProductRequest = (colorId) =>
  client.get(`${getImageProduct}?product_color_id=${colorId}`);

//////////////// Get Product Similar  ////////////////
export const getProductSimilarDetailsRequest = (id) =>
  client.get(`${getProductUrl}?category_id=${id}`);

//////////////// Get Categoris From SubMenu For Accessory  ////////////////
const getCategorisFromSubForAccessoryMenuUrl = "/category?type=اکسسوری";

export const getCategorisFromSubMenuForAccessoryRequest = () =>
  client.get(`${getCategorisFromSubForAccessoryMenuUrl}`);

//////////////// Get Categoris From SubMenu For Furniture  ////////////////
const getCategorisFromSubMenuForFurnitureUrl = "/category?type=مبلمان";

export const getCategorisFromSubMenuForFurnitureRequest = () =>
  client.get(`${getCategorisFromSubMenuForFurnitureUrl}`);

export const GetAmazingProductsAccessoryRequest = (values) =>
  client.get(
    `${getProductUrl}?skip=${values.skip}&limit=${
      values.limit ?? 10
    }&amazing_offer=true&category_type=اکسسوری`
  );

export const GetAmazingProductsSofaRequest = (values) =>
  client.get(
    `${getProductUrl}?skip=${values.skip}&limit=${
      values.limit ?? 10
    }&amazing_offer=true&category_type=مبلمان`
  );

//////////////// Contact us ////////////////
const contact_us_contentUrl = "/contact_us_content";
export const getContactUsRequest = () => client.get(`${contact_us_contentUrl}`);

//////////////// rules ////////////////
const rulesUrl = "/rules";
export const getRulesRequest = () => client.get(rulesUrl);

//////////////// privacy ////////////////
const privacyUrl = "/privacy";
export const getPrivacyRequest = () => client.get(privacyUrl);

//////////////// about_us ////////////////
const aboutUsUrl = "/about_us";
export const getAboutRequest = () => client.get(aboutUsUrl);

////////////////// Questions ////////////////
const questionUrl = "/common_question";
export const getQuestionRequest = () => client.get(questionUrl);

//////////////// news - article ////////////////
const getCategoryNewsUrl = "/article_category";
export const getCategoryNewsRequest = (values) =>
  client.get(
    `${getCategoryNewsUrl}?skip=${values.skip}&limit=${values.limit ?? 10}`
  );

const articleUrl = "/article";
export const getArticleRequest = (values) =>
  client.get(
    `${articleUrl}?skip=${values.skip}&limit=${values.limit ?? 10}${
      values.search ? "&search=" + convertNum(values.search) : ""
    }${values.id ? "&article_category_id=" + values.id : ""}`
  );
export const getArticleInfoRequest = (id) => client.get(`${articleUrl}/${id}`);

//////////////// contact us message ////////////////
const contact_us_messageUrl = "/contact_us_message";
export const addContactUsMessageRequest = (values) => {
  let data = {
    full_name: values.full_name,
    email: values.email,
    message: values.message,
  };
  return client.post(contact_us_messageUrl, data);
};

//////////////// contact us message ////////////////
const complaintUrl = "/complaint";
export const addComplaintMessageRequest = (values) => {
  let data = {
    full_name: values.full_name,
    email: values.email,
    message: values.message,
    subject: values.subject,
    phone_number: values.phone_number,
  };
  return client.post(complaintUrl, data);
};

////////////////// cart ////////////////
const cartUrl = "/user/cart";
export const getCartRequest = () => client.get(`${cartUrl}`);

const cartdeleteUrl = "/user/cart/product_color";
export const deleteCartOrderRequest = (id) =>
  client.delete(`${cartdeleteUrl}/${id}`);

export const addToCartRequest = (values) => {
  return client.post(`${cartUrl}`, {
    quantity: values.quantity,
    product_color_id: values.product_color_id,
  });
};

// ////////////////// order ////////////////

const addOrderUrl = "/user/order";
export const getOrdersRequest = (values) =>
  client.get(`${addOrderUrl}?skip=${values.skip}&limit=${values.limit ?? 10}`);
export const getOrderInfoRequest = (id) => client.get(`${addOrderUrl}/${id}`);
export const addOrderRequest = (values) => {
  let data = {
    user_address_id: values.user_address_id,
    discount_code: values.discount_code,
    description: values.description,
  };
  return client.post(addOrderUrl, data);
};

//////////////// Check User Discout Code //////////////
const addDiscountCodeUrl = "/user/discount_code/check";
export const addDiscountCodeRequest = (values) => {
  let data = {
    discount_code: values.discount_code,
  };
  return client.post(addDiscountCodeUrl, data);
};
//////////////// notif available //////////////
const availableUrl = "/user/notify_when_available";
export const NotifWhenAvailable = (values) => {
  let data = {
    product_id: values.product_id,
  };
  return client.post(availableUrl, data);
};

// ////////////////// comment ////////////////

const addCommentUrl = "/user/comment";
export const addCommentRequest = (values) => {
  let data = {
    product_id: values.product_id,
    title: values.title,
    text: values.description,
  };
  return client.post(addCommentUrl, data);
};

// ////////////////// comment ////////////////

const commentUrl = "/comment";
export const getCommentRequest = (values) =>
  client.get(
    `${commentUrl}?skip=${values.skip}&limit=${values.limit ?? 10}&product_id=${
      values.product_id
    }`
  );

// ////////////////// main slider ////////////////
const MainSliderUrl = "/main_slide";
export const getMainSliderRequest = () => client.get(MainSliderUrl);

// ////////////////// acc slider ////////////////
const AccessorySliderUrl = "/accessory_slide";
export const getAccessorySliderRequest = () => client.get(AccessorySliderUrl);

////////////////// ticket ///////////////////
const NewTicketUrl = "/user/ticket";
const EditTicketUrl = "/user/ticket_message";
export const addTicketRequest = (values) => {
  const formData = new FormData();

  formData.append("title", values.title);
  formData.append("file", values.file[0] == undefined ? "" : values.file[0]);
  formData.append("text", values.text);

  return client.post(NewTicketUrl, formData);
};
export const EditTicketRequest = (values) => {
  const formData = new FormData();

  formData.append("ticket_id", values.ticket_id);
  formData.append("file", values.file[0] == undefined ? "" : values.file[0]);
  formData.append("text", values.text);

  return client.post(EditTicketUrl, formData);
};
export const getTicketsRequest = (values) => {
  return client.get(
    `${NewTicketUrl}?skip=${values.skip}&limit=${values.limit ?? 10}`
  );
};
export const getTicketbyIdRequest = (id) => client.get(`${NewTicketUrl}/${id}`);

// ////////////////// Question ////////////////

const addQuestionUrl = "/user/question_and_answer";
export const addQuestionRequest = (values) => {
  let data = {
    product_id: values.product_id,
    text: values.description,
  };
  return client.post(addQuestionUrl, data);
};

const QuestionUrl = "/question_and_answer";
export const getQuestionAnswerRequest = (values) =>
  client.get(
    `${QuestionUrl}?skip=${values.skip}&limit=${
      values.limit ?? 10
    }&product_id=${values.product_id}`
  );

// ////////////////// Answer ////////////////

const addAnswerUrl = "/user/question_and_answer";
export const addAnswerRequest = (values) => {
  let data = {
    product_id: values.product_id,
    text: values.answer,
    question_id: values.question_id,
  };
  return client.post(addAnswerUrl, data);
};

//////////////// branch ////////////////
const branchUrl = "/branches";
export const getbranchRequest = () => client.get(branchUrl);

//////////////// how_to_order ////////////////
const how_to_orderUrl = "/how_to_order";
export const gethow_to_orderRequest = () => client.get(how_to_orderUrl);

//////////////// gallary ////////////////
const galleryUrl = "/gallery_image";
export const getGalleryRequest = () => client.get(galleryUrl);

//////////////// certificate ////////////////
const certificateUrl = "/certificate";
export const getCertificateRequest = () => client.get(certificateUrl);
